import "./style.css";
import "./experience.css";
import './ink.css';
import { Game } from "./game/game";

const canvas = document.getElementById("game-canvas");
if (!(canvas instanceof HTMLCanvasElement))
  throw new Error("无法初始化游戏画布。");

new Game(canvas);
